<script lang='ts'>
    import WishlistInner from './WishlistInner.svelte';
    import wishlist from "../../store/wishlist";
    import lang from '../../lang/language';
</script>

<div class='sticky-wishlist-wrapper'>
    <div class='sticky-wishlist-title'>
        {lang.wishlist} {wishlist.length ? `(${wishlist.length})` : ''}
    </div>
    <WishlistInner/>
</div>


<style>

    .sticky-wishlist-title {
        color: white;
        background-color: var(--primary-color);
        height: 40px;
        line-height: 30px;
        border: 2px solid var(--primary-color);
        padding: 5px 20px;
        text-align: center;
        margin-top: -1px;
        /*margin-left: -1px;*/
        width: 100.5%;
    }

    .sticky-wishlist-wrapper {
        border: 2px solid var(--primary-color);
        position: -webkit-sticky; /* Safari */
        position: sticky;
        top: 110px;
        background-color: rgba(255, 255, 255, .15);
        backdrop-filter: blur(5px);
        width: 100%;
        height: 75vh;
    }
</style>